export default "__VITE_ASSET__CdIce8aq__"